import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {Field} from '../../models';

@Component({
  selector: 'app-form-render-label',
  templateUrl: './form-render-label.component.html',
  styleUrls: ['./form-render-label.component.scss']
})
export class FormRenderLabelComponent implements OnInit, OnChanges {
  @Input() item: Field;
  fieldLabel: string;
  fieldHelp: string;
  fieldRequired: boolean;

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.item?.currentValue) {
      this.fieldLabel = changes?.item?.currentValue.options_obj.label;
      this.fieldHelp = changes?.item?.currentValue.options_obj.tooltip;
      this.fieldRequired = changes?.item?.currentValue.options_obj.isRequired;
    }
  }

  ngOnInit(): void {
  }

}
